import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { SBContainer } from "pages/provider/claimCodingOpt/styles";
import React, { useState } from "react";
import { DATE_FORMAT } from "utils/helper";

const STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
];

const ClaimSearch = ({ open, onClose, setNewPayload, newPayload }) => {
  const [status, setStatus] = useState("all");
  const [providerName, setProviderName] = useState("");
  const [dosFrom, setDosFrom] = useState("");
  const [dosTo, setDosTo] = useState("");
  const [error, setError] = useState("");

  const resetToInitialState = () => {
    setStatus("all");
    setProviderName("");
    setDosFrom("");
    setDosTo("");
    setError("");
  };

  const onSearch = () => {
    if (dosFrom && dosTo && dayjs(dosTo).isBefore(dayjs(dosFrom), "day")) {
      setError("To Date should be same as or after From Date");
      return;
    }
    const payload = {};
    if (dosFrom) {
      payload.dos_from = dayjs(dosFrom).format("MM/DD/YYYY");
    }
    if (dosFrom) {
      payload.dos_to = dayjs(dosTo).format("MM/DD/YYYY");
    }
    if (status) {
      payload.status = status;
    }
    if (providerName) {
      payload.provider_name = providerName;
    }
    setNewPayload(payload);
    resetToInitialState();
    onClose();
  };

  const onCancel = () => {
    if (!newPayload) {
      resetToInitialState();
    } else {
      setError("");
    }
    onClose();
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onCancel}>
      <DialogContent>
        <Box gap={2} display={"flex"} flexDirection={"column"}>
          <SBContainer>
            <Typography>Search Claim</Typography>
            <IconButton onClick={onCancel}>
              <Close />
            </IconButton>
          </SBContainer>
          <TextField
            label="Provider Name"
            fullWidth
            value={providerName}
            onChange={(e) => setProviderName(e.target.value)}
          />
          <DesktopDatePicker
            value={dayjs(dosFrom)}
            slotProps={{ textField: { variant: "outlined", fullWidth: true } }}
            onChange={(e) => setDosFrom(e)}
            format={DATE_FORMAT}
            placeholder={DATE_FORMAT}
            maxDate={dayjs()}
          />
          <DesktopDatePicker
            value={dayjs(dosTo)}
            slotProps={{ textField: { variant: "outlined", fullWidth: true } }}
            onChange={(e) => setDosTo(e)}
            format={DATE_FORMAT}
            placeholder={DATE_FORMAT}
            maxDate={dayjs()}
            minDate={dayjs(dosFrom)}
          />
          <TextField
            select
            label="Status"
            value={status}
            fullWidth
            onChange={(e) => setStatus(e.target.value)}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          {error && (
            <Typography variant="caption" color="error">
              {error}
            </Typography>
          )}
        </Box>
        <DialogActions>
          <Button variant="text" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSearch}>
            Search
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ClaimSearch;
